import { createApp } from "vue";
import { createPinia } from 'pinia';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import { initCookieConsent } from './lib/cookieConsent.js';
import { createMyPortalClient, setMyPortalClient } from './lib/myportalClient.js';
import App from "./App.vue";

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);
const myportalClient = createMyPortalClient();
setMyPortalClient(myportalClient);

app.provide('myportal', myportalClient);

initCookieConsent();
app.mount("#app");
